import type { WorkOrderAttemptCreateRequest } from '@/types/workOrderAttempt.types';
import type { LinkedHomeInspectionAttemptPayload } from './mapPsFirstAttemptToPayloads';

export type PsFirstAttemptDualSaveDeps = {
  patchPsAttempt: (args: {
    workOrderId: string;
    data: { create: WorkOrderAttemptCreateRequest[]; update: never[] };
  }) => Promise<unknown>;
};

export type PsFirstAttemptDualSaveInput = {
  psWorkOrderId: string;
  linkedHIWorkOrderID: string | null | undefined;
  psCreatePayload: WorkOrderAttemptCreateRequest;
  homeInspectionAttempt: LinkedHomeInspectionAttemptPayload;
};

export type PsFirstAttemptDualSaveResult =
  | { ok: true }
  | { ok: false; failedAt: 'missingLinkedHi' | 'ps'; error: unknown };

/**
 * First PS attempt with linked HI: single PATCH that nests homeInspectionAttempt.
 * The API creates the linked HI attempt in the same transaction (date/time from PS attempt).
 */
export const savePsFirstAttemptWithHi = async (
  input: PsFirstAttemptDualSaveInput,
  deps: PsFirstAttemptDualSaveDeps
): Promise<PsFirstAttemptDualSaveResult> => {
  if (!input.linkedHIWorkOrderID) {
    return { ok: false, failedAt: 'missingLinkedHi', error: new Error('Linked Home Inspection work order is missing') };
  }

  try {
    await deps.patchPsAttempt({
      workOrderId: input.psWorkOrderId,
      data: {
        create: [
          {
            ...input.psCreatePayload,
            homeInspectionAttempt: input.homeInspectionAttempt,
          },
        ],
        update: [],
      },
    });
  } catch (error) {
    return { ok: false, failedAt: 'ps', error };
  }

  return { ok: true };
};
